import { render, staticRenderFns } from "./AppBtnMenu.vue?vue&type=template&id=184a1d26"
import script from "./AppBtnMenu.vue?vue&type=script&lang=js"
export * from "./AppBtnMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports